module.exports = __webpack_public_path__ + "static/img/env16.9cc4186.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/env16.png
// module id = 109
// module chunks = 4